import { $host } from './index';

// AppointmentRequests
export const getAppointmentRequests = async (userId) => {
    const { data } = await $host.get(`web/appointment-requests/user/${userId}`);
    return data;
};

export const markAppointmentRequestComplete = async (id) => {
    const { data } = await $host.patch(`web/appointment-requests/${id}/complete`);
    return data;
};

// PaperRequests
export const getPaperRequests = async (userId) => {
    const { data } = await $host.get(`web/paper-requests/user/${userId}`);
    return data;
};

export const markPaperRequestProcessed = async (id) => {
    const { data } = await $host.patch(`web/paper-requests/${id}/process`);
    return data;
};

// CertificateRequests
export const getCertificateRequests = async (userId) => {
    const { data } = await $host.get(`web/certificate-requests/user/${userId}`);
    return data;
};

export const markCertificateRequestProcessed = async (id) => {
    const { data } = await $host.patch(`web/certificate-requests/${id}/process`);
    return data;
};
